import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { base } from '../api-config';
import { ParameterSetResponse, ParameterSetRequest } from '../models/parameter';

const endpoint = `${base}/parameters`;

@Injectable({
  providedIn: 'root'
})
export class ParameterSetService {

  constructor(private http: HttpClient) {}

  getAll(): Observable<ParameterSetResponse[]> {
    return this.http.get<ParameterSetResponse[]>(`${endpoint}/`);
  }

  get(id: number): Observable<ParameterSetResponse> {
    return this.http.get<ParameterSetResponse>(`${endpoint}/${id}`);
  }

  create(parameterSet: ParameterSetRequest): Observable<ParameterSetResponse> {
    return this.http.post<ParameterSetResponse>(`${endpoint}/`, parameterSet);
  }

  update(id: number, parameterSet: ParameterSetRequest): Observable<ParameterSetResponse> {
    return this.http.put<ParameterSetResponse>(`${endpoint}/${id}`, parameterSet);
  }

  delete(id: number): Observable<string> {
    return this.http.delete<string>(`${endpoint}/${id}`);
  }
}
